const maxWidthMap = {
  large: '640px',
  lg: '640px',
  small: '320px',
  sm: '320px',
  largeOnXS: '100%',
  fullScreen: '100%'
};
const widthMap = {
  large: '640px',
  lg: '640px',
  small: 'auto',
  sm: 'auto',
  largeOnXS: '100%',
  fullScreen: '100%'
};
const contentPaddingMap = {
  small: '0px 24px 0px 24px',
  sm: '0px 24px 0px 24px',
  large: '0px 32px 0px 32px',
  lg: '0px 32px 0px 32px',
  largeOnXS: '0px 16px 0px 16px',
  fullScreen: '0px 32px 0px 32px'
};
const actionsPaddingMap = {
  small: '8px 24px 24px 24px',
  sm: '8px 24px 24px 24px',
  large: '8px 32px 32px 32px',
  lg: '8px 32px 32px 32px',
  largeOnXS: '8px 16px 8px 8px',
  fullScreen: '8px 16px 32px 32px'
};
const resolveContentPadding = (size, layout) => {
  if (layout === 'stacked') {
    return {
      padding: contentPaddingMap[size],
      paddingBottom: '150px'
    };
  } else {
    return {
      padding: contentPaddingMap[size],
      paddingBottom: '70px'
    };
  }
};
export const largeOnXSStyle = (theme, size, hasOverflow, padding, layout) => ({
  '.MuiDialog-paper': {
    borderRadius: theme.tokens.ComponentModalBorderRadius,
    boxShadow: 'none',
    '&.MuiDialog-paperFullScreen': {
      borderRadius: '0px',
      border: `1px solid ${theme.tokens.ComponentModalBorderColor}`
    },
    maxWidth: maxWidthMap[size],
    width: widthMap[size]
  },
  '& .MuiDialogContent-root': {
    color: theme.tokens.ComponentModalBodyColor,
    ...(padding ? resolveContentPadding(size, layout) : {
      padding: 0
    }),
    //    ...(padding ? { paddingBottom: '70px' } : { paddingBottom: 0 }),

    '& p': {
      margin: '0px',
      fontSize: theme.tokens.ComponentModalBodyFontSize,
      color: theme.tokens.ComponentModalBodyColor,
      lineHeight: '125%'
    }
  },
  '& .MuiDialogActions-root': {
    position: hasOverflow ? 'absolute' : 'relative',
    bottom: hasOverflow ? '0' : 'auto',
    right: hasOverflow ? '0' : 'auto',
    width: hasOverflow ? '100%' : 'auto',
    padding: actionsPaddingMap[size],
    borderBottom: hasOverflow ? `1px solid ${theme.tokens.ComponentModalBorderColor}` : '0',
    borderTop: hasOverflow ? `1px solid ${theme.tokens.ComponentModalBorderColor}` : '0',
    backgroundColor: hasOverflow ? theme.tokens.ComponentModalFooterLargeOnXsBackgroundColor : theme.tokens.ComponentModalFooterBackgroundColor
  },
  '& .MuiDialog-container': {
    height: '100%'
  },
  '& .MuiBackdrop-root': {
    backgroundColor: theme.tokens.ComponentModalBackdropLargeOnXsColor
  }
});